export const PUBLIC_OFFER_DOCUMENT_VERSION = '2026-08-15-v0'

export const PUBLIC_OFFER_PATH = '/legal/offer'

/** Canonical public URL on the marketing site (preferred for users). */
export const PUBLIC_OFFER_EXTERNAL_URL = 'https://provisium.ru/offer/'

export const PRIVACY_POLICY_EXTERNAL_URL = 'https://provisium.ru/privacy/'

export const MARKETING_CONSENT_EXTERNAL_URL = 'https://provisium.ru/consent-marketing/'

export const REGISTER_PLAN_STORAGE_KEY = 'provisium.register.plan'

export type RegisterPlanId = 'start' | 'month' | 'year'

export const REGISTER_PLAN_LABELS: Record<RegisterPlanId, string> = {
  start: 'Старт',
  month: 'Месяц',
  year: 'Год',
}

export const parseRegisterPlan = (raw: string | null | undefined): RegisterPlanId => {
  const value = (raw ?? '').trim().toLowerCase()
  if (value === 'month' || value === 'monthly' || value === 'standard') {
    return 'month'
  }
  if (value === 'year' || value === 'yearly') {
    return 'year'
  }
  if (value === 'start' || value === 'free') {
    return 'start'
  }
  return 'start'
}

export const readStoredRegisterPlan = (): RegisterPlanId | null => {
  try {
    return parseRegisterPlan(sessionStorage.getItem(REGISTER_PLAN_STORAGE_KEY))
  } catch {
    return null
  }
}

export const storeRegisterPlan = (plan: RegisterPlanId) => {
  try {
    sessionStorage.setItem(REGISTER_PLAN_STORAGE_KEY, plan)
  } catch {
    // ignore quota / private mode
  }
}
